import axios from 'axios';

const getUsersInOrganization = (config) => {
  return axios.get('/api/users', config);
};

const getAllNonAdminUsersInOrg = (config) => {
  return axios.get('/api/users/all_non_admins', config);
};

const createUser = (user, disallowGlobalBadRequestPopups = false) => {
  return axios.post('/api/users', user, {
    disallowGlobalBadRequestPopups,
  });
};

const deleteUser = (email) => {
  return axios.delete(`/api/users/delete-single-user/${email}`);
};

const uploadUsersViaExcelValidation = (data) => {
  return axios.post('/api/users/excel-upload-validation', data);
};

const setUsersToCostCenter = (costCenter, users) => {
  return axios.post(`/api/users/set_users_for_cost_center/${costCenter}`, { users: users });
};

const saveUserTypeAppIcons = (appIcons, config) => {
  return axios.post('/api/users/save-app-icons', { appIcons }, config);
};

const getAdminUsers = () => {
  return axios.get('/api/users/admins');
};

const deleteAdminUser = (emails) => {
  return axios.delete('/api/admin/delete_admin', { data: { emails } });
};

const getCurrentUserInfo = () => {
  return axios.get('/api/admin/me');
};

const updateUserData = (userData) => {
  return axios.put('/api/users/update_user_data', userData);
};

const averageTimeSpent = (startDate, endDate, byMonth /*0 or 1*/) => {
  if (byMonth === 0 || byMonth === 1) {
    return axios.get(`/api/users/average-time-spent?startDate=${startDate}&endDate=${endDate}&byMonth=${byMonth}`);
  } else {
    throw new Error('byMonth must be either 0 or 1');
  }
};

const getEvents = (startDate, endDate, usersIds) => {
  return axios.post('/api/users/events', { startDate: startDate, endDate: endDate, usersIds: usersIds });
};

const getAllEventsForUser = (startDate, endDate, userId) => {
  return axios.get(`/api/users/all-events-for-user?startDate=${startDate}&endDate=${endDate}&userId=${userId}`);
};

const setDefaultTheme = async (theme) => {
  return axios.post('/api/admin/setDefaultTheme', theme);
};

const getUserPageColumns = () => {
  return axios.get('/api/users/getUserPageColumns');
};

const updateUserPageColumns = (pageColumns) => {
  return axios.post('/api/users/updateUserPageColumns', pageColumns);
};

const createAdminUser = (newUser) => {
  const data = { newUser, organizations: newUser.orgData };
  return axios.post('/api/admin/createAdminUser/forge', data);
};

const updateAdminUser = (userToUpdate) => {
  const data = { userToUpdate, organizations: userToUpdate.orgData };
  return axios.post('/api/admin/updateAdminUser/forge', data);
};

const deleteMultipleUserClients = (emails) => {
  return axios.post('/api/users/delete-multiple-users/', { emails: emails });
};

const updateUserClient = (userToUpdate) => {
  const data = { userToUpdate };
  return axios.post('/api/users/update_user_client', data);
};

const saveUsersFromExcel = (usersToUpload) => {
  const data = { users: usersToUpload };
  return axios.post('/api/users/saveUsersFromExcel', data);
};

const getOrganizationAccessIcons = () => {
  return axios.get('/api/users/get-organization-access');
};

const saveOrganizationAccessIcons = (appIconNames) => {
  return axios.post('/api/users/save-organization-access', { appIconNames });
};
const getAllUsersFromAdminDB = () => {
  return axios.get('/api/admin/getAllUsersFromAdminDB');
};

export {
  setUsersToCostCenter,
  createUser,
  getUsersInOrganization,
  deleteUser,
  saveUserTypeAppIcons,
  getAdminUsers,
  deleteAdminUser,
  getCurrentUserInfo,
  updateUserData,
  averageTimeSpent,
  getEvents,
  getAllEventsForUser,
  uploadUsersViaExcelValidation,
  setDefaultTheme,
  getUserPageColumns,
  updateUserPageColumns,
  createAdminUser,
  updateAdminUser,
  deleteMultipleUserClients,
  updateUserClient,
  saveUsersFromExcel,
  getOrganizationAccessIcons,
  saveOrganizationAccessIcons,
  getAllNonAdminUsersInOrg,
  getAllUsersFromAdminDB,
};
